import { canUseDOM } from 'src/libs/canUseDOM';

export function checkIPadOS(ua: string) {
  if (!canUseDOM()) {
    return false;
  }

  const notIOS = !/ipad|iphone|ipod/.test(ua);
  const macOS = /mac os/.test(ua);

  return !!(macOS && notIOS && typeof (navigator as any).standalone === 'boolean');
}

export function detectIOS(ua?: string) {
  if (!ua) {
    ua = canUseDOM() ? window.navigator.userAgent.toLowerCase() : '';
  }

  const isIPadOS = checkIPadOS(ua);
  const isIPad = isIPadOS || ua.indexOf('ipad') !== -1;
  const isIPhone = !isIPad && ua.search(/iphone|ipod/) !== -1;
  const isIOS = isIPhone || isIPad;

  return {
    isIOS,
    isIPhone,
    isIPad,
    isIPadOS,
  };
}

export function detectAndroid(ua?: string) {
  if (!ua) {
    ua = canUseDOM() ? window.navigator.userAgent.toLowerCase() : '';
  }

  const isAndroid = /Android/.test(ua);

  return { isAndroid };
}
